<template>
    <div class="assignment">
        <!-- <create-dialog v-model="dialog" :item="item" @fetch="fetchData"></create-dialog> -->
         
        <v-card class="rounded-xl " flat>
            <v-card-title class="text-h6 font-weight-bold">
                Phiếu công tác
            <v-spacer></v-spacer> 
            
            <div class="d-flex align-center wrapper mx-1 my-1">
                <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
            </div>
            <v-divider vertical class="mx-4"></v-divider>

            <v-btn outlined @click="exportPromt=true" color="teal darken-4" class="d-flex rounded-xl" style="text-transform: none;" >Xuất excel</v-btn>
            
            <v-btn v-if="selectedItems.length > 0" @click="bulkAccept" :loading="isBulkApproving" dark color="orange darken-4" class="rounded-lg ml-4" large> 
                <v-icon left>mdi-check-all</v-icon> Duyệt đã chọn ({{ selectedItems.length }})
            </v-btn>
            
            <v-btn @click="adminDialog=!adminDialog" dark color="teal darken-4" class="rounded-lg ml-4" large> <v-icon left>mdi-plus</v-icon> Tạo phiếu </v-btn>


            <export-prompt v-model="exportPromt" url="BusinessRequests" :timeLimit="true" fileName="DU_LIEU_PHIEU_CONG_TAC"></export-prompt>
            <!-- <data-filter v-model="params" :filter="filter" @fetchData="fetchData">
            </data-filter> -->
            </v-card-title>
            
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <div class="d-flex align-center wrapper mx-2 my-2">
                        <month-picker width="7rem" v-model="month" label="Tháng" outlined dense></month-picker>
                    </div>
                    <!-- <v-text-field label="Ngày xét" outlined type="date" v-model="filters.execDate" hide-details dense
                    class="mx-1 my-1 flex-grow-0 flex-shrink-1" style=""
                    ></v-text-field> -->

                    <!-- start filtering -->
                    <v-text-field label="Mã phiếu" dense v-model="filters.code" outlined hide-details persistent-placeholder
                        class="mx-2 my-2 flex-shrink-1" style="background-color: white;" placeholder="BRQ..."></v-text-field>
 
                    <v-select label="Trạng thái" placeholder="Chọn" dense v-model="filters.status" outlined hide-details
                        :items="[{text:'Tất cả', value:-1},{text:'Chờ XN', value:0}, {text:'Đã XN', value:1}, {text:'Từ chối', value:2}]"
                        class="mx-2 my-2 flex-shrink-1" style="max-width: 200px;background-color: white;"></v-select>

                    <v-text-field label="Mã NS" placeholder="NS0000" dense v-model="filters.employeeCode" outlined hide-details persistent-placeholder
                    class="mx-2 my-2 flex-shrink-1" style="background-color: white;"></v-text-field>
                        
                    <v-text-field label="Tên NS" dense v-model="filters.employeeName" outlined hide-details persistent-placeholder placeholder="Tên Nhân Sự .. "
                        class="mx-2 my-2 flex-shrink-1" style="background-color: white;"></v-text-field>
                        
                        
                    <v-autocomplete label="Phòng ban" clearable outlined :items="departments.map(x=> {
                            return {
                                text: x.name,
                                value: x.code
                            }
                        })" v-model="filters.departmentCode" dense hide-details persistent-placeholder
                        class="mx-2 my-2 flex-shrink-1" style="min-width: 250px;background-color: white;"></v-autocomplete>

                    <v-select label="Loại" clearable outlined :items="formData.businessTypes"  item-text="name" item-value="code" v-model="filters.businessTypeCode"
                        dense hide-details persistent-placeholder
                        class="mx-2 my-2 flex-shrink-1" style="min-width: 150px;max-width: 300px;background-color: white;"></v-select>
                        
                    <v-text-field label="Ngày áp dụng" type="date" clearable dense v-model="filters.date" outlined hide-details persistent-placeholder placeholder="Ngày áp dụng"
                        class="mx-2 my-2 flex-shrink-1" style="max-width: 200px;background-color: white;"></v-text-field>
                </div>
            </v-sheet>
            <!-- ******** dialog ADMIN ********  -->
            <v-dialog v-model="adminDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                        Tạo mới đơn đi công tác <v-spacer></v-spacer> <v-icon small @click="adminDialog=false">mdi-close</v-icon>
                    </v-card-title>
                    <v-form @submit.prevent="saveData" v-model="valid" ref="form">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete v-model="form.employeeCode"  @update:search-input="fetchEmployee" label="Nhân viên *" 
                                        :filter="customFilter"
                                        hide-no-data :items="employees" item-text="name" item-value="code">
                                        <template v-slot:item="data">
                                            <strong>{{ data.item.code }}: </strong> {{` ${data.item.name} - ${data.item.department}`}}
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <date-picker2 v-model="form.date" :range="false" label="Ngày áp dụng"></date-picker2>
                                </v-col>
                                
                                <v-col cols="12" md="6">
                                    <v-text-field step='0.5' v-model="form.amount" label="Giờ công tác" type="number" :rules="[x=>x%0.5==0||'Không hợp lệ']"></v-text-field>
                                </v-col>
                                <v-col cols="12" >
                                    <v-autocomplete v-model="form.businessTypeCode" :items="formData.businessTypes" item-text="name" item-value="code" label="Lý do">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea v-model="form.note" solo flat outlined label="Diễn giải">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark color="primary" type="submit" small>
                                Lưu
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            
            <!-- summarize sections -->
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phiếu: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Chờ duyệt: <b class="ml-1">{{ pendingCount }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-check-circle-outline</v-icon>
                    Đã duyệt: <b class="ml-1">{{ confirmedCount }}</b>
                </v-chip>
                <v-chip color="red lighten-4" text-color="red darken-4" class="font-weight-medium" small>
                    <v-icon left small>mdi-close-circle-outline</v-icon>
                     Từ chối: <b class="ml-1">{{ rejectedCount }}</b>
                </v-chip>
            </v-sheet>
            
            <v-data-table
                v-model="selectedItems"
                show-select
                item-key="code"
                :mobile-breakpoint="0"
                height="600px" fixed-header
                :headers="headers"
                :items="items"
                :loading="isLoading"
                loading-text="Đang tải dữ liệu..."
                :footer-props="{
                    itemsPerPageOptions:[
                    50, 100, 200
                    ]
                }"
            >
                <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                    <v-simple-checkbox v-if="item.status === 0" :ripple="false" color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                </template>

                <template v-slot:[`item.employeeInfo`]="{item}">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.employeeName}}</div>
                    <div class="caption grey--text">{{item.employeeCode}}</div>
                </template>

                <template v-slot:[`item.processInfo`]="{item}">
                    <div style="line-height: 1.3;"><span class="grey--text caption">Gửi:</span> {{formatDate(item.sentDate)}}</div>
                    <div v-if="item.confirmedBy" style="line-height: 1.3;"><span class="grey--text caption">Duyệt:</span> {{item.confirmedBy}}</div>
                    <div v-if="item.confirmedDate && item.status != 0" style="line-height: 1.3;"><span class="grey--text caption">Lúc:</span> {{formatDate(item.confirmedDate)}}</div>
                </template>
                
                <template v-slot:[`item.actions`]="{item}" >
                    <!-- ********* Edit ****** -->
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 green--text text--darken-3 font-weight-bold" color="green lighten-4" @click="accept(item)">
                        <v-icon left small>mdi-check-circle</v-icon> Duyệt
                    </v-btn>

                    <!-- ********* Xoa ****** -->
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 red--text text--darken-3 font-weight-bold" color="red lighten-4" @click="decline(item)" >
                        <v-icon left small>mdi-close-circle</v-icon> Từ chối
                    </v-btn>

                    <!-- ********* Undo ****** -->
                    <v-btn x-small depressed rounded class="mx-1 my-1 blue-grey--text text--darken-3 font-weight-bold" v-if="item.status != 0" color="blue-grey lighten-4" @click="undo(item)" >
                        <v-icon left small>mdi-undo</v-icon> Hoàn tác
                    </v-btn>
                    
                    <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold" color="grey lighten-4" @click="remove(item)" v-show="item.status == 0">
                        <v-icon left small>mdi-delete</v-icon> Xóa
                    </v-btn>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="$helper.formatStatus(item.status).color" small dark>
                        {{$helper.formatStatus(item.status).text}}
                    </v-chip>
                </template>
                <template v-slot:[`item.departmentName`]="{ item }">
                    <v-chip class="ma-2 caption font-weight-bold" color="teal darken-4" label text-color="white" >
                    <v-icon left>
                        mdi-store
                    </v-icon>
                    {{item.departmentName}}
                    </v-chip>
                </template>

                <template v-slot:[`item.date`]="{ item }">
                    {{formatDate(item.date)}}
                </template>
            </v-data-table>
        </v-card>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import ApiServices from '@/components/services/ApiServices';
import DataFilter from '@/components/DataFilter';
// import CreateDialog from './Create.vue';
import * as moment from "moment/moment";

export default {
    name: "Attendance",
    components: {
        'data-filter': DataFilter,
        // 'create-dialog': CreateDialog,

    },
    props: ["icon"],
    watch: {
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                // this.fetchData();
            },
            deep: true,
        },
        month:{
            handler(val){
                this.filters.from=moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to=moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
                this.fetchData()
            }
        }
    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        pendingCount() {
            return this.items.filter((item) => item.status === 0).length;
        },
        confirmedCount() {
            return this.items.filter((item) => item.status === 1).length;
        },
        rejectedCount() {
            return this.items.filter((item) => item.status === 2).length;
        },
        totalCount() {
            return this.items.length;
        }
    },
    data () {
        return {
            ROOT_URL: "BusinessRequests/",
            BUSINESSTYPE_URL: "businesstypes/",
            adminDialog: false,
            exportPromt: false,
            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize: 10000
            },

            month: moment().format("YYYY-MM"),
            leavePlans:[],
            filters:{
                status: -1,
                code: null,
                employeeCode: null,
                employeeName: null,
                departmentCode: null,
                businessTypeCode:null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
                date: null,
            },
            rowCount: 0,

            departmentSearch:null,
            departments: [],

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn:["DepartmentTypeCode"],
                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },
            
            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            selectedItems: [],
            isBulkApproving: false,
            search:"",
            options: {},
            isLoading: true,

            dialog: false, item: null,
            dialogDelete: false,
            targetItem: undefined,

            headers: [
                { text: 'Thao tác', value: 'actions', width: '8rem'},
                { text: 'Mã', align: 'start', value: 'code', width: '5rem',  
                    filter: value => {
                    if (!this.filters.code) return true
                    return value.toLowerCase().includes(this.filters.code.toLowerCase())
                    }
                },
                { text: 'Trạng thái', align: 'start', value: 'status', width: '6rem',  
                    filter: value => {
                    if ( this.filters.status == -1) return true
                    return value === this.filters.status
                    }
                },
                { text: '', value: 'businessTypeCode', align: ' d-none',  
                    filter: value => {
                    if ( !this.filters.businessTypeCode) return true
                    return value === this.filters.businessTypeCode
                    }
                 },
                { text: 'Loại công tác', align: 'start', value: 'businessTypeName', width: '9rem'},
                { text: 'Nhân viên', align: 'start', value: 'employeeInfo', width: '10rem'},
                { text: '', align: ' d-none', value: 'employeeCode',  
                    filter: value => {
                    if (!this.filters.employeeCode) return true
                    return value.toLowerCase().includes(this.filters.employeeCode.toLowerCase())
                    }
                },
                { text: '', align: ' d-none', value: 'employeeName',
                    filter: value => {
                    if (!this.filters.employeeName) return true
                    return value.toLowerCase().includes(this.filters.employeeName.toLowerCase())
                    }
                },
                { text: '', align: ' d-none', value: 'departmentCode', 
                    filter: value => {
                    if ( !this.filters.departmentCode) return true
                    return value === this.filters.departmentCode
                    }
                },
                { text: 'Phòng ban', align: 'start', value: 'departmentName', width: '8rem'},
                { text: 'Ngày áp dụng', align: 'start', value: 'date', width: '8rem',  
                    filter: value => {
                    if (!this.filters.date) return true
                    return value == (this.filters.date)
                    }
                },
                { text: 'Số giờ', align: 'start', value: 'amount'},
                { text: 'Ghi chú', align: 'start', value: 'note', width: '10rem'},
                { text: 'Trạng thái xử lý', align: 'start', value: 'processInfo', width: '11rem'},
                { text: '', align: ' d-none', value: 'sentDate'},
                { text: '', align: ' d-none', value: 'confirmedBy'},
                { text: '', align: ' d-none', value: 'confirmDate'},
            ],

            valid: false,
            employees:[],
            formData: {
                businessTypes: [],
            },
            form: {
                businessTypeCode: "",
                date: new Date().toISOString().substr(0,10),
                note: "",
                amountOvertime: 0,
                symbol: "",
            },

            defaultForm: {
                businessTypeCode: "",
                date: new Date().toISOString().substr(0,10),
                note: "",
                amountOvertime: 0,
                symbol: "",
            },
        }
    },
    methods: {
        customFilter(item, queryText, itemText) {
            return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        },
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        formatStatus(value){
            switch(value){
                case 0:{
                    return "Chờ duyệt";
                }
                case 1:{
                    return "Chấp nhận";
                }
                case 2:{
                    return "Từ chối";
                }
            }
        },
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        fetchLeavePlan(){
            ApiServices.fetchLeavePlan().then(res=>{
                this.leavePlans = res.data;
            })
        },
        fetchDepartment() {
            return http.get("departments/fetch").then(res => {
                this.departments = res.data;
            })
        },
        fetchData () {
            this.isLoading = true;
            return http.get(this.ROOT_URL+'admin/', {
                params: this.params
            })
            .then(res => {
                this.items = res.data.results;
                this.rowCount = res.data.rowCount;
            })
            .catch(err => {

            })
            .finally(() => {
                this.isLoading = false;
            })
        },
        
        saveData() {
            this.$refs.form.validate();
            if(this.valid)
            {
                return http.post(this.ROOT_URL + "admin", this.form)
                .then(res => {
                    this.fetchData();
                    this.adminDialog = false;
                })
                .catch(err => {
                });
            }
        },
        
        accept(item) {
            return http.get(this.ROOT_URL + "accept/" + item.code).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },

        bulkAccept() {
            if (this.selectedItems.length === 0) return;
            this.isBulkApproving = true;
            const itemsToApprove = this.selectedItems.filter(item => item.status === 0);
            
            let promise = Promise.resolve();
            itemsToApprove.forEach(item => {
                promise = promise.then(() => {
                    return http.get(this.ROOT_URL + "accept/" + item.code).catch(error => {
                        console.error("Error accepting item: " + item.code, error);
                    });
                });
            });
            
            promise.finally(() => {
                this.isBulkApproving = false;
                this.selectedItems = [];
                this.fetchData();
            });
        },

        decline(item) {
            return http.get(this.ROOT_URL + "decline/" + item.code).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },

        undo(item) {
            http.get(this.ROOT_URL + "undo/" + item.code).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        
        cfmDeleteItem() {
            http.delete(this.ROOT_URL+ 'admin/' +this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },

        fetchBusinessType () {
            return http.get(this.BUSINESSTYPE_URL)
            .then(res => {
                this.formData.businessTypes = res.data.items;
            }).catch(err => {throw err})

        },
        fetchEmployee(val){
            ApiServices.fetchEmployee(val).then(res=>{
                this.employees = res.data;
                console.log(res.data);
            })
        },
    },
    created () {
        this.fetchData();
        this.fetchBusinessType();
        this.fetchDepartment()
    }
}
</script>
<style scoped>
    /* ::v-deep table > tbody > tr:nth-child(1)>td {
        padding-right: 1px !important;
        padding-left: 1px !important;
    } */
</style>